import React, { useLayoutEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../../sass/files/gallery.scss";
import "../../sass/files/gallery-page.scss";
import Carousel from "../homepage/components/gallery/component/GalleryCarousel";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";

const GalleryPage = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "auto",
      });

      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    // Reset immediately before the page is painted.
    scrollToTop();

    // Reset again after React completes the layout.
    const frameId = window.requestAnimationFrame(scrollToTop);

    // Handles delayed layout changes from images and fonts and Swiper.
    const timerId = window.setTimeout(scrollToTop, 100);

    return () => {
      window.cancelAnimationFrame(frameId);
      window.clearTimeout(timerId);
    };
  }, [location.pathname]);

  return (
    <>
      <Navbar />

      <div className="gallery-page">
        {/* Hero */}
        <section className="hero gallery-section gallery-page-hero">
          <div className="hero-body">
            <p className="gallery-page-eyebrow">
              Real Work. Real Clients.
            </p>

            <p className="gallery-title mb-8">
              Explore Our Gallery
            </p>

            <p className="gallery-subtitle gallery-page-subtitle">
              Browse custom sculpts we've hand-crafted for clients around the
              world
            </p>
          </div>
        </section>

        {/* Filterable project carousel */}
        <section className="gallery-page-carousel-section">
          <div
            className="grid grid-cols-1 gap-4 items-center"
            id="gallery"
          >
            <div className="flex items-center flex-cols">
              <Carousel />
            </div>
          </div>
        </section>

        {/* Closing CTA */}
        <section className="gallery-page-cta-section">
          <p className="gallery-page-cta-title">
            Ready to get your own custom sculpt?
          </p>

          <div className="gallery-page-cta-buttons">
            <Link
              to="/guest-quote"
              className="gallery-page-cta-btn gallery-page-cta-btn-primary"
            >
              Get a Free Quote
            </Link>

            <Link
              to="/review"
              className="gallery-page-cta-btn gallery-page-cta-btn-secondary"
            >
              See Customer Reviews →
            </Link>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default GalleryPage;